/* @flow */
import React from 'react';
import ReactDOM from 'react-dom';
import style from './less/main.less'
import FilterApp from './components/smart/FilterApp.react.js'

// import old schools scripts
import $ from 'jquery'
window.jQuery = window.$ = $
import 'jquery-ui-bundle'
import correctCaptcha from './oldJs/lib/captcha'
window.correctCaptcha = correctCaptcha
import './oldJs/lib/windowUtils'
import './oldJs/lib/capacitor'
import './oldJs/lib/eu-footer'
// import './oldJs/lib/footer-image'
import './oldJs/lib/gallery'
import './oldJs/lib/navbar-top'
import './oldJs/lib/numbers'
import './oldJs/lib/popups'
import './oldJs/lib/references'
import './oldJs/lib/svg-inliner'
import './oldJs/lib/utilities'
import './oldJs/lib/carousel-fixed-height'
import './oldJs/lib/loop-fader'
import './oldJs/lib/references-filter-updater'
import './oldJs/lib/click-analytics'
import './oldJs/lib/touch-device-menu'
import './oldJs/lib/email-js'
import './oldJs/lib/attachment-cancel'
import './lib/hiring'

const projectEl = document.getElementById('projects-filters-app')
if (projectEl)
  ReactDOM.render(
    <FilterApp
      filters={window.projectFilters}
      minMax={['investment']}
      model="Project"
      isUserLoggedIn={window.isUserLoggedIn}
      lang={window.lang}
      dataLayer={window.dataLayer}
    />,
    projectEl
  );

const companyEl = document.getElementById('companies-filters-app')
if (companyEl)
  ReactDOM.render(
    <FilterApp
      filters={window.companyFilters}
      minMax={['sales', 'EBITDA']}
      model="Company"
      lang={window.lang}
    />,
    companyEl
  );

// import Root from './app/Root';
// import configureReporting from '../common/configureReporting';
// import configureStore from '../common/configureStore';
// import createStorageEngine from 'redux-storage-engine-localstorage';
// import uuid from 'uuid';
// import { fromJSON } from '../common/transit';
//
// const initialState = fromJSON(window.__INITIAL_STATE__); // eslint-disable-line no-underscore-dangle
//
// const reportingMiddleware = configureReporting({
//   appVersion: initialState.config.appVersion,
//   sentryUrl: initialState.config.sentryUrl,
//   unhandledRejection: fn => window.addEventListener('unhandledrejection', fn),
// });
//
// const store = configureStore({
//   initialState,
//   platformDeps: { createStorageEngine, uuid },
//   platformMiddleware: [reportingMiddleware],
// });
//
// const appElement = document.getElementById('app');
//
// // Initial render.
// ReactDOM.render(
//   <Root store={store} />
// , appElement);
//
// // Hot reload render.
// // gist.github.com/gaearon/06bd9e2223556cb0d841#file-naive-js
// if (module.hot && typeof module.hot.accept === 'function') {
//   module.hot.accept('./app/Root', () => {
//     const NextRoot = require('./app/Root').default;
//
//     ReactDOM.render(
//       <NextRoot store={store} />
//     , appElement);
//   });
// }



// WEBPACK FOOTER //
// ./src/browser/main.js